import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

const FoodIntoleranceIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 18 17"}>
      <path d="M8.99893 10.5234C8.01478 10.5234 7.06578 10.6407 6.16552 10.7868L5.85202 14.9321C5.81983 15.3582 5.9668 15.7785 6.25762 16.0915C6.54793 16.4052 6.95581 16.5831 7.38363 16.5831H10.5422C10.97 16.5831 11.3779 16.4052 11.6682 16.0915C11.9591 15.7785 12.106 15.3582 12.0738 14.9321L11.7594 10.7752C10.8805 10.6348 9.9563 10.5234 8.99893 10.5234Z" />
      <path d="M8.99998 0C4.0289 0 0 4.46426 0 8.21749C0 9.77487 0.693555 10.2302 1.86052 10.2302C3.50572 10.2302 6.09191 9.32483 8.99998 9.32483C11.9081 9.32483 14.4938 10.2302 16.1389 10.2302C17.3059 10.2302 18 9.77429 18 8.21749C18 4.46426 13.9706 0 8.99998 0ZM7.70544 3.17207C5.38317 3.17207 3.3933 5.30822 3.3933 7.05697C3.3933 7.38824 3.12528 7.65626 2.79401 7.65626C2.46278 7.65626 2.19472 7.3882 2.19472 7.05697C2.19472 4.706 4.60187 1.97349 7.70544 1.97349C8.0367 1.97349 8.30476 2.24155 8.30476 2.57278C8.30476 2.90401 8.03667 3.17207 7.70544 3.17207Z" />
    </SvgIcon>
  );
};

export default FoodIntoleranceIcon;
